import { FC } from 'react';

import { PUBLIC_IMAGES } from '../../../../config';

import NewsCard from '@/components/NewsCard';
import { INews } from '@/types';

interface INewsProps {
  news: INews[];
}

export const News: FC<INewsProps> = ({ news }) => (
  <div className="w-screen">
    <div className="h-[510px] w-screen bg-cover" style={{ backgroundImage: `url(${PUBLIC_IMAGES.NEWS_BG})` }} />

    <div className="container mt-[-180px]">
      <div className="max-w-[562px] px-3 md:px-0">
        <NewsCard news={news[0]} />
      </div>
    </div>
  </div>
);
